import { render, staticRenderFns } from "./arinvbilling.vue?vue&type=template&id=56af2728"
import script from "./arinvbilling.vue?vue&type=script&lang=js"
export * from "./arinvbilling.vue?vue&type=script&lang=js"
import style0 from "./arinvbilling.vue?vue&type=style&index=0&id=56af2728&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports